import BigNumber from 'bignumber.js/bignumber'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BASE_URL = 'https://nomiswap.io'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/liquidity/add`
export const BASE_REMOVE_LIQUIDITY_URL = `${BASE_URL}/liquidity/remove`

export const DEFAULT_TOKEN_DECIMAL = 18
export const DEFAULT_GAS_LIMIT = 500000
